<app-register-company-welcome
    *ngIf="stepNumber === 0"
    [isProcessing]="isProcessing"
    (next)="nextStep()">
</app-register-company-welcome>

<app-register-company-account
    *ngIf="stepNumber === 1"
    [company]="newCompany"
    [isProcessing]="isProcessing"
    (persist)="persistForm()"
    (next)="nextStep()"
    (back)="previousStep()">
</app-register-company-account>

<app-register-company-legal-data
    *ngIf="stepNumber === 2"
    [company]="newCompany"
    [isProcessing]="isProcessing"
    [id_front_file]="id_front_file"
    [id_back_file]="id_back_file"
    [cf_front_file]="cf_front_file"
    [cf_back_file]="cf_back_file"
    [uploadingFields]="documentUploadStates"
    [uploadErrors]="documentUploadErrors"
    (persist)="persistForm()"
    (next)="nextStep()"
    (documentChosen)="chooseDocument($event.event, $event.field)"
    (documentDropped)="onDocumentDrop($event.event, $event.field)">
</app-register-company-legal-data>

<app-register-company-legal-contacts
    *ngIf="stepNumber === 3"
    [company]="newCompany"
    [isProcessing]="isProcessing"
    [provinces]="provinces"
    [cities]="cities"
    [(showPassword)]="showPassword"
    (persist)="persistForm()"
    (next)="nextStep()"
    (back)="previousStep()"
    (legalCitiesNeedUpdate)="updateCitiesLegal()">
</app-register-company-legal-contacts>

<app-register-company-company-info
    *ngIf="stepNumber === 4"
    [company]="newCompany"
    [isProcessing]="isProcessing"
    [provinces]="provinces"
    [cities]="cities"
    (persist)="persistForm()"
    (next)="nextStep()"
    (back)="previousStep()"
    (companyCitiesNeedUpdate)="updateCitiesCompany()">
</app-register-company-company-info>

<app-register-company-services
    *ngIf="stepNumber === 5"
    [company]="newCompany"
    [isProcessing]="isProcessing"
    [services]="services"
    [servicesSelected]="servicesSelected"
    [(billingPeriod)]="billingPeriod"
    [tariffTiers]="tariffTiers"
    (persist)="persistForm()"
    (next)="nextStep()"
    (back)="previousStep()"
    (planSelected)="selectPlan($event)">
</app-register-company-services>

<app-register-company-terms
    *ngIf="stepNumber === 6"
    [isProcessing]="isProcessing"
    [(companyTermsAndCondition1)]="companyTermsAndCondition1"
    [(companyTermsAndCondition2)]="companyTermsAndCondition2"
    [(companyTermsAndCondition3)]="companyTermsAndCondition3"
    (persist)="persistForm()"
    (next)="nextStep()"
    (back)="previousStep()">
</app-register-company-terms>

<app-register-company-otp
    *ngIf="stepNumber === 7"
    [company]="newCompany"
    [isProcessing]="isProcessing"
    [(OTPCode)]="OTPCode"
    [showResendOtpButton]="showResendOtpButton"
    [showOtpResendCountdown]="showOtpResendCountdown"
    [otpResendSecondsLeft]="otpResendSecondsLeft"
    [isResendingOtp]="isResendingOtp"
    (next)="nextStep()"
    (back)="previousStep()"
    (verify)="checkOTP($event.otp, $event.email)"
    (resend)="resendOtp()">
</app-register-company-otp>

<app-register-company-payment
    *ngIf="stepNumber === 8 && servicesSelected[0]"
    [company]="newCompany"
    [planId]="servicesSelected[0].id"
    [billingPeriod]="billingPeriod"
    (next)="onPaymentCompleted()"
    (back)="previousStep()">
</app-register-company-payment>

<app-register-company-congratulations
    *ngIf="stepNumber === 9"
    (goToLogin)="backToLogin()">
</app-register-company-congratulations>
